import React from 'react';
import { Triangle } from 'react-loader-spinner';
const Loader = () => {
  return (
    <div
      style={{ minHeight: '80vh' }}
      className='flex items-center h-full'
    >
      <Triangle
        height='80'
        width='80'
        color='#4fa94d'
        ariaLabel='triangle-loading'
        wrapperStyle={{}}
        wrapperClassName=''
        visible={true}
      />
    </div>
  );
};

export default Loader;
